import React, { useEffect } from 'react';
import { FrInvestmentMicroFrontend } from '@securitize/reactjs-mfe';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { SecuritizePage } from '@securitize/ui-components';
import { getOpportunity } from '../OpportunitiesDetailsPage/actions';
import { configs } from '../../../../../config';
import { MixPanel } from '../../../../../utils/helpers/mixPanel';
import { buildOpportunity, buildUserInfo } from '../../../../../utils/helpers/buildInfoForMFE';

const InvestmentWizardMicrofrontend = () => {
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const {
    issuerConfiguration: { config },
    auth: { user },
    investment,
  } = useSelector((state) => state);
  const opportunityDetails = investment.opportunity.data;

  const docusignRedirectConfigName = `docusign-redirect-${user?.investorId}`;
  const KYCUrl = `${
    config.securitizeIdUrl
  }/#/profile/verification/type?issuerId=${
    config.issuerId
  }&scope=info%20details%20verification`;

  useEffect(() => {
    dispatch(getOpportunity(id));
  }, []);

  if (investment.opportunity.isLoading) {
    return <SecuritizePage isLoading />;
  }

  const userInfo = buildUserInfo(user, config);

  const opportunity = buildOpportunity(opportunityDetails, config);

  if (!opportunity || !userInfo) {
    return null;
  }

  return (
    <FrInvestmentMicroFrontend
      basePath={`/opportunity/${id}/investment`}
      entryPointUrl={configs.INVESTMENT_MFE_ENTRY_POINT}
      history={history}
      params={{
        clientData: {
          type: 'NIE',
          logo: config.logo,
          name: config.issuerName,
        },
        externalRoutes: {
          LOGIN: '/login',
          KYC: KYCUrl,
          OPPORTUNITIES_LIST: '/opportunities',
          OPPORTUNITY_DETAILS: `/opportunity/${id}`,
          QUALIFICATION_REQUIRED: `/opportunity/${id}/qualification`,
          HOLDINGS: '/portfolio',
        },
        hideSuitabilitySteps: true,
        docusignRedirectConfigName,
        opportunity,
        styleOverrides: {
          TEXT_PRIMARY: 'issuer-text-primary',
          BUTTON_PRIMARY: 'issuer-button-primary',
          BUTTON_PRIMARY_DISABLED: 'issuer-button-primary-disabled',
          BUTTON_OUTLINE_SECONDARY: 'issuer-button-outline',
          LINK: 'btn-link',
          SPINNER_PRIMARY: 'CircularProgressbar-path',
          RADIO_BUTTON: 'issuer-radio-btn',
          DISCLAIMER: 'disclaimer',
        },
        mixPanel: MixPanel,
      }}
      userInfo={userInfo}
    />
  );
};

export default InvestmentWizardMicrofrontend;
